export const AUTH_TOKEN_KEY = "plantz-auth-token";
